import customParseFormat from "dayjs/plugin/customParseFormat"
import dayjs from 'dayjs'
dayjs.extend(customParseFormat)

export const isValidDate = (date: string, format: string = 'DD-MM-YYYY') => {
  const dateDayjs = dayjs(date, format, true) // `true` enables strict parsing
  return { isValid: dateDayjs.isValid(), date: dateDayjs.toDate() }
}
